<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title></ion-title>
        <ion-buttons slot="start">
            <span show-md  style="padding-left: 0px; padding-right: 10px;">Kaart</span>
            <input
                #inpSearchRef
                placeholder="Tekst filter"
                class="inputField" style="width: 10em;"
                onclick="this.select();"
                (input)='onChangeSearch($any($event.target).value)'
                [(ngModel)]='inpSearch'
            >
            <ion-select aria-label="Orders"
                [(ngModel)]="filterOrders"
                (ionChange)='onChangeSearch($any($event.target).value)'
            >
                <ion-select-option value="No">Objecten</ion-select-option>
                <ion-select-option value="Open">Orders</ion-select-option>
            </ion-select>
            <ion-select aria-label="Omschrijving"
                [(ngModel)]="filterObjOmschr"
                (ionChange)='onChangeSearch($any($event.target).value)'
            >
                <ion-select-option value="">Alle omschrijvingen</ion-select-option>
                <ion-select-option *ngFor="let obj of objOmschrn" [value]="obj">{{obj}}</ion-select-option>
            </ion-select>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content [class]="(showMap) ? 'showMap' : '' ">
    <div [class]="(showMap) ? 'gmap' : 'outOfSight'">
        <capacitor-google-map #googlemap></capacitor-google-map>
    </div>
</ion-content>
